<template>
  <el-dialog
    :title="props.dialogTitle"
    :visible="props.visible"
    width="70vw"
    :close-on-click-modal="false"
    class="page-dialog center-dialog"
    @update:visible="val => emit('update:visible', val)"
    @closed="handleClosed"
  >
    <div class="dialog-content">
      <LanguageRadioButtons :value="currentLang" :options="languageOptions" @input="handleLangInput" />
      <el-form ref="formRef" :model="localFormData" :rules="formRules" label-position="top" size="small">
        <!-- 标题 -->
        <el-form-item label="标题" prop="title">
          <el-input
            v-for="opt in languageOptions"
            :key="opt.value"
            v-show="opt.value === currentLang"
            v-model="localFormData.title[opt.value]"
            placeholder="请输入公告标题（100个字符以内）"
            maxlength="100"
            show-word-limit
          />
        </el-form-item>

        <!-- 内容 -->
        <el-form-item label="内容" prop="content">
          <Tinymce
            v-for="opt in languageOptions"
            v-if="props.visible"
            :key="`notice-content-${opt.value}-${tinymceKey}`"
            v-show="opt.value === currentLang"
            :value="localFormData.content[opt.value]"
            @input="val => (localFormData.content[opt.value] = val)"
            :height="260"
            language="zh"
          />
        </el-form-item>

        <!-- 跳转类型 -->
        <!-- <el-form-item label="跳转类型" prop="jump_type">
          <el-radio-group v-model="localFormData.jump_type" @change="handleJumpTypeChange">
            <el-radio :label="0">指定链接</el-radio>
            <el-radio :label="1">平台活动</el-radio>
          </el-radio-group>
        </el-form-item> -->

        <!-- 指定链接配置 -->
        <!--
        <div v-if="localFormData.jump_type === 0">

          <el-form-item label="链接类型" prop="link_type">
            <el-select v-model="localFormData.link_type" placeholder="请选择链接类型" @change="handleLinkTypeChange">
              <el-option label="无链接" :value="0"></el-option>
              <el-option label="站内链接" :value="1"></el-option>
              <el-option label="站外链接" :value="2"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item v-if="localFormData.link_type !== 0" label="打开方式" prop="open_type">
            <el-radio-group v-model="localFormData.open_type">
              <el-radio :label="0">新页签</el-radio>
              <el-radio :label="1">内嵌</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item v-if="localFormData.link_type !== 0" label="详情链接" prop="link_url">
            <el-input v-model="localFormData.link_url" :disabled="localFormData.link_type === 0" placeholder="请输入详情链接" maxlength="255" show-word-limit></el-input>
            <div v-if="localFormData.link_type === 1" class="link-tip">站内链接必须以 / 开头</div>
            <div v-else-if="localFormData.link_type === 2" class="link-tip">站外链接必须以 http:// 或 https:// 开头</div>
          </el-form-item>
        </div>

        <div v-else-if="localFormData.jump_type === 1">
          <el-form-item label="平台活动" prop="activity_id">
            <el-select v-model="localFormData.activity_id" placeholder="请选择平台活动">
              <el-option v-for="item in activityOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </div>
        -->

        <!-- 公告类型 -->
        <el-form-item label="公告类型" prop="type">
          <el-radio-group v-model="localFormData.type">
            <el-radio :label="1">普通公告</el-radio>
            <el-radio :label="2">特殊公告</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否弹窗显示" prop="is_popup">
          <el-radio-group v-model="localFormData.is_popup">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="2">否</el-radio>
          </el-radio-group>
        </el-form-item>

        <!-- 展示配置 -->
        <el-form-item label="展示配置">
          <div class="display-config">
            <div class="config-row">
              <span class="config-label">
                <el-tooltip content="定时启用选项输入时间后才能生效，输入时间为空时，选项不会生效！" placement="top">
                  <i class="el-icon-question config-icon"></i>
                </el-tooltip>
                定时启用
              </span>
              <el-date-picker
                @change="handleEnableAtChange"
                v-model="localFormData.enable_at"
                type="datetime"
                placeholder="请选择启用时间（可选）"
                style="width: 260px"
              ></el-date-picker>
            </div>
            <div class="config-row">
              <span class="config-label">
                <el-tooltip content="定时停用选项输入时间后才能生效，输入时间为空时，选项不会生效！" placement="top">
                  <i class="el-icon-question config-icon"></i>
                </el-tooltip>
                定时停用
              </span>
              <el-date-picker v-model="localFormData.disable_at" type="datetime" placeholder="请选择停用时间（可选）" style="width: 260px"></el-date-picker>
            </div>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" :loading="loading" @click="handleConfirm">确认</el-button>
    </div>
  </el-dialog>
</template>

<script setup>
import { addAnnouncement, updateAnnouncement } from '@/api/content/announcement'
import Tinymce from '@/components/Tinymce'
import LanguageRadioButtons from '@/components/LanguageRadioButtons'
import config from '@/config'
import { computed, nextTick, reactive, ref, watch } from 'vue'
import { Message } from 'element-ui'

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  dialogTitle: {
    type: String,
    default: '新增系统公告',
  },
  formData: {
    type: Object,
    default: () => ({}),
  },
})

const emit = defineEmits(['update:visible', 'success'])

const firstLang = Array.isArray(config.languages) && config.languages.length > 0 ? config.languages[0]?.value : 'EN'
const languageOptions = Array.isArray(config.languages) ? config.languages : []

function buildLangTextObj(initialValue = '') {
  const obj = {}
  for (let i = 0; i < languageOptions.length; i += 1) {
    const k = languageOptions[i]?.value
    if (k != null) obj[k] = initialValue
  }
  return obj
}

const formRef = ref(null)
const loading = ref(false)
const activityOptions = ref([
  { label: '首存赠送活动', value: 1 },
  { label: '每日签到活动', value: 2 },
])

const tinymceKey = ref(0)
const currentLang = ref(firstLang)

function handleEnableAtChange(val) {
  console.log('handleEnableAtChange', val)
}
const localFormData = reactive({
  id: null,
  title: buildLangTextObj(''),
  content: buildLangTextObj(''),
  jump_type: 0,
  link_type: 0,
  open_type: 0,
  link_url: '',
  activity_id: 0,
  type: 1,
  enable_at: '',
  disable_at: '',
  is_popup: 2,
})

const titleText = computed({
  get() {
    const v = localFormData.title?.[currentLang.value]
    return v == null ? '' : String(v)
  },
  set(val) {
    localFormData.title[currentLang.value] = val
  },
})

const formRules = computed(() => {
  return {
    title: [
      {
        validator: (rule, value, callback) => {
          const t = titleText.value
          if (!t) {
            callback(new Error('请输入公告标题'))
            return
          }
          if (t.length > 100) {
            callback(new Error('标题不能超过100个字符'))
            return
          }
          callback()
        },
        trigger: 'blur',
      },
    ],
    content: [
      {
        validator: (rule, value, callback) => {
          const c = localFormData.content?.[currentLang.value]
          if (!c) {
            callback(new Error('请输入公告内容'))
            return
          }
          const maxLen = 1000 * 1024 * 2
          if (String(c).length > maxLen) {
            callback(new Error('内容不能超过1000个字符'))
            return
          }
          callback()
        },
        trigger: 'blur',
      },
    ],
    jump_type: [{ required: true, message: '请选择跳转类型', trigger: 'change' }],
    link_type: [
      {
        required: localFormData.jump_type === 0,
        message: '请选择链接类型',
        trigger: 'change',
      },
    ],
    open_type: [
      {
        required: localFormData.jump_type === 0 && localFormData.link_type !== 0,
        message: '请选择打开方式',
        trigger: 'change',
      },
    ],
    link_url: [
      {
        required: localFormData.jump_type === 0 && localFormData.link_type !== 0,
        message: '请输入详情链接',
        trigger: 'blur',
      },
      {
        validator: (rule, value, callback) => {
          if (localFormData.jump_type !== 0 || localFormData.link_type === 0) {
            callback()
            return
          }
          if (!value) {
            callback(new Error('请输入详情链接'))
            return
          }
          if (localFormData.link_type === 1) {
            if (!value.startsWith('/')) {
              callback(new Error('站内链接必须以 / 开头'))
            } else {
              callback()
            }
          } else if (localFormData.link_type === 2) {
            if (!value.startsWith('http://') && !value.startsWith('https://')) {
              callback(new Error('站外链接必须以 http:// 或 https:// 开头'))
            } else {
              callback()
            }
          } else {
            callback()
          }
        },
        trigger: 'blur',
      },
    ],
    activity_id: [
      {
        required: localFormData.jump_type === 1,
        message: '请选择平台活动',
        trigger: 'change',
      },
    ],
    type: [{ required: true, message: '请选择公告类型', trigger: 'change' }],
    is_popup: [{ required: true, message: '请选择是否弹窗显示', trigger: 'change' }],
  }
})

watch(
  () => props.visible,
  v => {
    if (v) initForm()
  }
)

function toDate(value) {
  if (!value) return ''
  const num = Number(value)
  if (!Number.isNaN(num)) {
    const len = String(Math.abs(num)).length
    if (len === 10) return new Date(num * 1000)
    return new Date(num)
  }
  return new Date(value)
}

async function initForm() {
  const emptyTitle = buildLangTextObj('')
  const emptyContent = buildLangTextObj('')
  const defaultData = {
    id: null,
    title: emptyTitle,
    content: emptyContent,
    jump_type: 0,
    link_type: 0,
    open_type: 0,
    link_url: '',
    activity_id: 0,
    type: 1,
    enable_at: '',
    disable_at: '',
    is_popup: 2,
  }

  const incoming = { ...(props.formData || {}) }

  const normalizeI18nField = val => {
    if (val && typeof val === 'object' && !Array.isArray(val)) return val
    if (typeof val === 'string') return { [currentLang.value]: val }
    return {}
  }

  if (typeof incoming.jump_type === 'number' && incoming.jump_type > 0) incoming.jump_type = incoming.jump_type - 1
  if (typeof incoming.link_type === 'number' && incoming.link_type > 0) incoming.link_type = incoming.link_type - 1
  if (typeof incoming.open_type === 'number' && incoming.open_type > 0) incoming.open_type = incoming.open_type - 1

  console.log('incoming.enable_at', incoming.enable_at)
  console.log('incoming.disable_at', incoming.disable_at)
  incoming.enable_at = incoming.enable_at ? toDate(incoming.enable_at) : ''
  incoming.disable_at = incoming.disable_at ? toDate(incoming.disable_at) : ''

  if (incoming.title && typeof incoming.title === 'object' && !Array.isArray(incoming.title)) {
    const langs = languageOptions.map(o => o.value)
    const found = langs.find(k => incoming.title && incoming.title[k] != null)
    if (found) currentLang.value = found
  }
  if (incoming.content && typeof incoming.content === 'object' && !Array.isArray(incoming.content)) {
    const langs = languageOptions.map(o => o.value)
    const found = langs.find(k => incoming.content && incoming.content[k] != null)
    if (found) currentLang.value = found
  }

  incoming.title = { ...emptyTitle, ...normalizeI18nField(incoming.title) }
  incoming.content = { ...emptyContent, ...normalizeI18nField(incoming.content) }

  Object.assign(localFormData, defaultData, incoming)

  await nextTick()
  if (formRef.value) formRef.value.clearValidate()
}

function handleJumpTypeChange() {
  if (localFormData.jump_type === 0) {
    localFormData.activity_id = 0
  } else {
    localFormData.link_type = 0
    localFormData.open_type = 0
    localFormData.link_url = ''
  }
}

function handleLinkTypeChange() {
  if (localFormData.link_type === 0) {
    localFormData.open_type = 0
    localFormData.link_url = ''
  }
}

function handleTitleInput(val) {
  localFormData.title[currentLang.value] = val
}

function handleLangInput(val) {
  currentLang.value = val
}

function handleContentInput(val) {
  localFormData.content[currentLang.value] = val
}

function handleCancel() {
  emit('update:visible', false)
}

function handleClosed() {
  formRef.value && formRef.value.resetFields()
  Object.assign(localFormData, {
    id: null,
    title: buildLangTextObj(''),
    content: buildLangTextObj(''),
    jump_type: 0,
    link_type: 0,
    open_type: 0,
    link_url: '',
    activity_id: 0,
    type: 1,
    enable_at: '',
    disable_at: '',
    is_popup: 2,
  })
  currentLang.value = firstLang
  tinymceKey.value += 1
}

function validateForm() {
  return new Promise((resolve, reject) => {
    if (!formRef.value) return reject(new Error('no_form_ref'))
    formRef.value.validate(valid => {
      if (valid) {
        const { enable_at, disable_at } = localFormData
        if (enable_at && disable_at && disable_at.getTime() <= enable_at.getTime()) {
          Message.error('停用时间必须大于启用时间')
          reject(new Error('invalid_time'))
          return
        }
        resolve()
      } else {
        reject(new Error('validate_failed'))
      }
    })
  })
}

function buildPayload() {
  const isLinkJump = localFormData.jump_type === 0
  return {
    id: localFormData.id,
    title: localFormData.title, //titleText.value,
    content: localFormData.content, //contentText.value,
    jump_type: localFormData.jump_type + 1,
    link_type: isLinkJump ? localFormData.link_type + 1 : 0,
    link_url: isLinkJump && localFormData.link_type !== 0 ? localFormData.link_url : '',
    open_type: isLinkJump && localFormData.link_type !== 0 ? localFormData.open_type + 1 : 0,
    activity_id: localFormData.jump_type === 1 ? localFormData.activity_id : 0,
    type: localFormData.type,
    enable_at: localFormData.enable_at ? localFormData.enable_at.getTime() : 0,
    disable_at: localFormData.disable_at ? localFormData.disable_at.getTime() : 0,
    is_popup: localFormData.is_popup || 2,
  }
}

async function handleConfirm() {
  try {
    await validateForm()
  } catch (e) {
    return
  }
  const payload = buildPayload()

  loading.value = true
  try {
    let resp
    if (payload.id) {
      resp = await updateAnnouncement(payload)
    } else {
      const { id: _id, ...rest } = payload
      resp = await addAnnouncement(rest)
    }

    if (resp && resp.code === 0) {
      Message.success('保存成功')
      emit('success')
      handleCancel()
    } else if (resp) {
      Message.error(resp.msg || '保存失败')
    }
  } catch (error) {
    Message.error(error.message || '保存失败')
  } finally {
    loading.value = false
  }
}
</script>

<style lang="scss" scoped>
.dialog-content {
  overflow-y: hidden;
  padding-bottom: 12px;
  padding-right: 4px;
}

.link-tip {
  margin-top: 4px;
  font-size: 12px;
  color: #909399;
}

.display-config {
  .config-row {
    display: flex;
    align-items: center;
    margin-bottom: 8px;

    .config-label {
      width: 72px;
      color: #606266;
      font-size: 13px;
      display: flex;
      align-items: center;

      .config-icon {
        margin-right: 4px;
        color: #c0c4cc;
        font-size: 14px;
      }
    }
  }
}
</style>
